import React from "react";
import AdminShell from "../admin/AdminShell";
import {
  employerNavigationSections,
  flattenEmployerNavigationSections,
} from "../../config/employerNavigation";
import EmployerTrainingChrome from "./EmployerTrainingChrome";
import EmployerTrainingCoachPanel from "./EmployerTrainingCoachPanel";
import { useEmployerMode } from "./EmployerModeContext";

function EmployerShellBody({
  badge = "Experts4Europe Employer",
  shellLabel = "Employer Case OS",
  shellDescription = "Jobs, Kandidaten, Dokumente, Filing, Integration und Analytics laufen in einer zusammenhaengenden operativen Arbeitsflaeche.",
  modeLabel = "Live-Betrieb",
  liveLabel = "Employer",
  utilityHref = "/dashboard/account",
  utilityLabel = "Konto",
  topSignal = "Employer Operating System",
  topContext = "Arbeitsraum",
  workspaceTitle = "Experts4Europe Employer OS",
  workspaceNotice = "Employer-Unterseiten teilen dieselbe Case-, Evidenz-, Dokumenten- und Aktionslogik.",
  searchTitle = "Employer OS",
  searchDescription = "Suche nach Arbeitsraeumen, Anzeigen, Kandidaten, Dokumenten, Filing und Integrationsbereichen.",
  searchPlaceholder = "Job, Kandidat, Dokument, Filing ...",
  searchEmptyText = "Keine passende Employer-Aktion gefunden.",
  profileLinks = [
    { href: "/dashboard/employer", label: "Uebersicht" },
    { href: "/dashboard/employer/jobs", label: "Anzeigen" },
    { href: "/dashboard/employer/candidates", label: "Kandidaten" },
    { href: "/dashboard/employer/profile", label: "Arbeitgeberprofil" },
    { href: "/dashboard/account", label: "Konto" },
  ],
  navSections = employerNavigationSections,
  navItems = null,
  searchItems = null,
  children,
  ...props
}) {
  const { isTraining } = useEmployerMode();

  const resolvedSearchItems = searchItems || flattenEmployerNavigationSections(navSections);

  return (
    <AdminShell
      badge={badge}
      shellLabel={shellLabel}
      shellDescription={shellDescription}
      modeLabel={isTraining ? "Trainingsmodus" : modeLabel}
      liveLabel={liveLabel}
      utilityHref={utilityHref}
      utilityLabel={utilityLabel}
      topSignal={topSignal}
      topContext={topContext}
      workspaceTitle={workspaceTitle}
      workspaceNotice={workspaceNotice}
      searchTitle={searchTitle}
      searchDescription={searchDescription}
      searchPlaceholder={searchPlaceholder}
      searchEmptyText={searchEmptyText}
      profileLinks={profileLinks}
      navSections={navSections}
      navItems={navItems}
      searchItems={resolvedSearchItems}
      family="employer"
      shellClassName={isTraining ? "employer-shell employer-shell--training" : "employer-shell"}
      {...props}
    >
      <EmployerTrainingChrome />
      <EmployerTrainingCoachPanel />
      {children}
    </AdminShell>
  );
}

export default function EmployerShell({
  badge = "Experts4Europe Employer",
  shellLabel = "Employer Case OS",
  shellDescription = "Jobs, Kandidaten, Dokumente, Filing, Integration und Analytics laufen in einer zusammenhaengenden operativen Arbeitsflaeche.",
  modeLabel = "Live-Betrieb",
  liveLabel = "Employer",
  utilityHref = "/dashboard/account",
  utilityLabel = "Konto",
  topSignal = "Employer Operating System",
  topContext = "Arbeitsraum",
  workspaceTitle = "Experts4Europe Employer OS",
  workspaceNotice = "Employer-Unterseiten teilen dieselbe Case-, Evidenz-, Dokumenten- und Aktionslogik.",
  searchTitle = "Employer OS",
  searchDescription = "Suche nach Arbeitsraeumen, Anzeigen, Kandidaten, Dokumenten, Filing und Integrationsbereichen.",
  searchPlaceholder = "Job, Kandidat, Dokument, Filing ...",
  searchEmptyText = "Keine passende Employer-Aktion gefunden.",
  profileLinks = [
    { href: "/dashboard/employer", label: "Uebersicht" },
    { href: "/dashboard/employer/jobs", label: "Anzeigen" },
    { href: "/dashboard/employer/candidates", label: "Kandidaten" },
    { href: "/dashboard/employer/profile", label: "Arbeitgeberprofil" },
    { href: "/dashboard/account", label: "Konto" },
  ],
  navSections = employerNavigationSections,
  navItems = null,
  searchItems = null,
  ...props
}) {
  return (
    <EmployerShellBody
      badge={badge}
      shellLabel={shellLabel}
      shellDescription={shellDescription}
      modeLabel={modeLabel}
      liveLabel={liveLabel}
      utilityHref={utilityHref}
      utilityLabel={utilityLabel}
      topSignal={topSignal}
      topContext={topContext}
      workspaceTitle={workspaceTitle}
      workspaceNotice={workspaceNotice}
      searchTitle={searchTitle}
      searchDescription={searchDescription}
      searchPlaceholder={searchPlaceholder}
      searchEmptyText={searchEmptyText}
      profileLinks={profileLinks}
      navSections={navSections}
      navItems={navItems}
      searchItems={searchItems}
      {...props}
    />
  );
}
